<template>
  <v-dialog
    :value="value"
    max-width="1400"
    width="95vw"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-toolbar dense flat>
        <v-toolbar-title>
          Pessoas cadastradas - {{ assessor.nome }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-text-field
          :value="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
          class="mb-4"
          @input="$emit('update:search', $event)"
        ></v-text-field>
        <v-data-table
          :headers="detalheHeaders"
          :items="pessoas"
          :search="search"
          :loading="loading"
          :options.sync="detalheOptions"
          height="60vh"
          class="elevation-1"
          fixed-header
          loading-text="Carregando..."
          no-data-text="Sem registros para este assessor."
        >
          <template v-slot:item.created_at="{ item }">
            {{ formatDateTime(item.created_at) }}
          </template>
          <template v-slot:item.cad_dup="{ item }">
            <span :class="{ 'red--text': item.cad_dup === 1 }">
              {{ item.cad_dup === 1 ? "Duplicado" : "Ok" }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDateTime } from "../utils/formatters";

export default {
  name: "AssessorDetalheModal",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    assessor: {
      type: Object,
      default: () => ({ id: null, nome: "" }),
    },
    pessoas: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      detalheHeaders: [
        { text: "ID", value: "idpessoa" },
        { text: "Nome Completo", value: "nome_completo" },
        { text: "Telefone", value: "telefone" },
        { text: "Email", value: "email" },
        { text: "Data cadastro", value: "created_at" },
        { text: "Zona", value: "zona" },
        { text: "Secao", value: "secao" },
        { text: "Duplicado", value: "cad_dup" },
      ],
      detalheOptions: {
        sortBy: ["created_at"],
        sortDesc: [true],
        itemsPerPage: 25,
      },
    };
  },
  methods: {
    formatDateTime,
  },
};
</script>

<style scoped>
/* Estilos específicos do modal (se necessário) */
</style>
